
import { RdcCard } from "./RdcCard";
export { default as RdcCardHeader } from "./RdcCardHeader";

export default RdcCard;
